/**
 * BuildingEmptyState — contextual empty state for the buildings table.
 * @param {{ type: 'no-data' | 'no-results', onAddBuilding?: () => void, onClearFilters?: () => void }} props
 */
const BuildingEmptyState = ({ type, onAddBuilding, onClearFilters }) => {
  if (type === 'no-data') {
    return (
      <div className="ap-empty">
        <div className="ap-empty__icon-wrap">
          <svg className="ap-icon-xl ap-empty__icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819" />
          </svg>
        </div>
        <h3 className="ap-empty__title">No buildings yet</h3>
        <p className="ap-empty__text">
          Get started by adding your first building. Buildings help organize areas by physical location and address.
        </p>
        {onAddBuilding ? (
          <button
            type="button"
            onClick={onAddBuilding}
            className="ap-btn ap-btn--primary"
          >
            <svg className="ap-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Add Building
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="ap-empty">
      <div className="ap-empty__icon-wrap">
        <svg className="ap-icon-xl ap-empty__icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
      </div>
      <h3 className="ap-empty__title">No results found</h3>
      <p className="ap-empty__text">
        No buildings match your current search or filter criteria. Try adjusting your search terms or clearing filters.
      </p>
      {onClearFilters ? (
        <button
          type="button"
          onClick={onClearFilters}
          className="ap-btn ap-btn--outline"
        >
          <svg className="ap-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Clear All Filters
        </button>
      ) : null}
    </div>
  );
};

export default BuildingEmptyState;
